const ITEMS = [
  "Coconut Shell Charcoal",
  "Shisha Briquettes",
  "BBQ Briquettes",
  "Indonesian Sourcing",
  "Export Coordination",
  "Private Label",
  "FOB / CIF",
  "Bulk Supply",
];

export default function Marquee({ dark = true }) {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden py-8 sm:py-10 border-y select-none ${
        dark ? "bg-charcoal border-white/10" : "bg-offwhite border-charcoal/10"
      }`}
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span
                  className={`font-display text-4xl sm:text-6xl font-black tracking-tight px-6 sm:px-10 whitespace-nowrap ${
                    i % 2 === 0
                      ? dark
                        ? "text-outline"
                        : "text-outline-dark"
                      : dark
                      ? "text-offwhite/85"
                      : "text-charcoal/85"
                  }`}
                >
                  {item}
                </span>
                <span className={`w-2 h-2 rotate-45 ${dark ? "bg-clay" : "bg-forest"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
